import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { scrollbar } from '../../foundation/scrollbar/index.js';

var TextAreaContainer = styled.div.withConfig({
  displayName: "TextAreaContainer",
  componentId: "sc-1kmeycb-0"
})(["position:relative;width:100%;display:flex;gap:", ";"], themeGet('spacing.md'));
var TextAreaFocusLine = styled.div.withConfig({
  displayName: "TextAreaFocusLine",
  componentId: "sc-1kmeycb-1"
})(["width:", ";height:", ";margin-top:", ";background-color:", ";transition:opacity 175ms ease-in-out;opacity:", ";"], pxToRem(2), pxToRem(24), pxToRem(4), themeGet('colors.blue.500'), function (props) {
  return props.$hasFocus ? 1 : 0;
});
var StyledTextArea = styled.textarea.withConfig({
  displayName: "StyledTextArea",
  componentId: "sc-1kmeycb-2"
})(["", ";width:100%;padding:0;padding-top:", ";resize:none;border:none;outline:none;color:", ";font-size:", ";line-height:", ";background-color:", ";"], scrollbar(), pxToRem(5), themeGet('colors.text.300'), themeGet('fontSize.medium'), themeGet('lineHeight.default'), themeGet('colors.gray.0'));

export { StyledTextArea, TextAreaContainer, TextAreaFocusLine };
